/**
 * The tab logic of `RecordTabs` and `RecordLayout`, kept out of the component files so they
 * only export components (the `react-refresh/only-export-components` rule flags mixed
 * exports). Not named `recordTabs.ts`: on a case-insensitive filesystem that would collide
 * with `RecordTabs.tsx`.
 */

export interface RecordTab {
  key: string
  label: string
  /** Shown after the label: "Contactpersonen 3". */
  count?: number
}

export function tabId(idPrefix: string, key: string): string {
  return `${idPrefix}-tab-${key}`
}

/** Focus a tab from elsewhere on the page ("Alle contactpersonen →"). */
export function focusTab(idPrefix: string, key: string): void {
  document.getElementById(tabId(idPrefix, key))?.focus()
}

/** The tabs a relation page gets on a phone only (ED-50): the right and the left column. */
export const MOBILE_TABS: readonly RecordTab[] = [
  { key: 'koppelingen', label: 'Koppelingen' },
  { key: 'gegevens', label: 'Gegevens' },
]

/**
 * The tab to show: a phone-only tab in a desktop URL, or an unknown one, shows the first
 * tab. `mobileTabs` are the phone-only tabs this page has (no Koppelingen without a right
 * column).
 */
export function effectiveTab(
  active: string,
  tabs: readonly RecordTab[],
  desktop: boolean,
  mobileTabs: readonly RecordTab[] = MOBILE_TABS,
): string {
  const own = tabs.some((tab) => tab.key === active)
  const mobile = !desktop && mobileTabs.some((tab) => tab.key === active)
  return own || mobile ? active : (tabs[0]?.key ?? '')
}
